export const IN_PROGRESS = Object.freeze({
	DESCRIPTION:
		'Actualmente estamos procesando la información de tu archivo. Este proceso puede llevar algún tiempo, y te pedimos paciencia mientras trabajamos para completarlo de manera eficiente. Este procedimiento puede llevar entre 5 y 10 minutos, dependiendo de la complejidad del archivo. Una vez que el proceso haya terminado, serás redirigido automáticamente a la pantalla correspondiente.',
});
